import React from 'react';
import FilterTable from './filterTable';
import { ClientTableColumnCaptions } from './tableColumnCaptions';
import FavoriteItemColumnFormatter from './favoriteItemColumnFormatter';

const ClientTable = props => {
  const columns = [{
    dataField: 'formalName',
    text: ClientTableColumnCaptions['formalName'],
    sort: true,
    filter_: { type: 'text' },
  }, {
    dataField: 'legalAddress',
    text: ClientTableColumnCaptions['legalAddress'],
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'taxId',
    text: ClientTableColumnCaptions['taxId'],
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'contactPerson',
    text: ClientTableColumnCaptions['contactPerson'],
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'e_mail',
    text: ClientTableColumnCaptions['e_mail'],
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'phone',
    text: ClientTableColumnCaptions['phone'],
    sort: true,
    filter_: { type: 'text' }
  }, {
    dataField: 'isFavorite',
    text: ClientTableColumnCaptions['isFavorite'],
    sort: false,
    align: 'center',
    filter_: {
      type: 'select',
      values: {
        'all': '',
        'favorite': 'true',
      }
    },
    headerStyle: () => ({width: '35px'}),
    formatter: (cell, row) => <FavoriteItemColumnFormatter
      cell={cell} row={row}
      actions={props.actions}/>,
  }];

  const defaultSorted = [{
    dataField: 'name',
    order: 'asc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="clients"
      data={props.clients}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no clients"
    />
  );
};

export default ClientTable;



// WEBPACK FOOTER //
// ./src/components/clientTable.js